import Api from "@/config/api/user.js";
import { APIError } from "@/utils/Error";
import CommonUtil from "@/utils/CommonUtil.js";
import MemberErrorCode from "@/config/api/member-error-code.js";
import EncryptionUtil from "@/utils/EncryptionUtil";
import { ENCRYPTION_VERSION } from "@/utils/Constants";
import commonUtil from "@/utils/CommonUtil.js";

export default {
  state: {
    // Mypage Error Data for Error Handler
    mypageErrorData: {
      code: 0, // Error Code
      message: "", // Error Message
      value: {} // Return Value
    },
    common: {
      sessionKey: "" // Session Key
    },
    mypageToken: {
      //mypage token refresh를 위한 코드
      access_token: "",
      refresh_token: ""
    },
    profile: {
      social_type: "",
      email_id: "",
      country_number_id: "",
      phone_id: "",
      email: "",
      country_number: "",
      phone: "",
      nickname: "",
      name: "",
      gender: "",
      birth: "",
      parent_phone: "",
      parent_name: "",
      change_pw_date: "",
      regist_date: "",
      agree_email_receive: "",
      agree_phone_receive: "",
      is_person: false,
      is_legacy: false,
      is_transfer: false,
      email_id_possession: false,
      phone_id_possession: false,
      is_sns: false,
      is_id: false
    },
    service: {
      list: [],
      info: {
        member_service_type: ""
      },
      updateResult: false,
      possession: {
        sendType: "",
        sendResult: false,
        sendCount: 0,
        certifycateResult: false,
        changeResult: false
      }
    },
    setting: {
      marketingAgree: false,
      terms: []
    },
    userPossessionInfo: {
      session_key: "",
      email_id: "",
      email_possession: "",
      phone_id: "",
      phone_possession: false,
      force_possession: false
    }
  },
  getters: {
    getMypageToken: (state) => {
      return state.mypageToken;
    }
  },
  mutations: {
    // Init Common Error Data
    INIT_MYPAGE_ERROR_DATA(state) {
      state.mypageErrorData.code = 0;
      state.mypageErrorData.message = "";
    },
    // Set Common Error Data
    SET_MYPAGE_ERROR_DATA(state, response) {
      state.mypageErrorData.code = response.code;
      state.mypageErrorData.value = response.value;

      // Get Error Message
      const errorMessageInfo = MemberErrorCode.find((obj) => obj.code === response.code);

      if (CommonUtil.isNotEmpty(errorMessageInfo)) {
        state.mypageErrorData.message = errorMessageInfo.message;
      } else {
        // Not Defined Error Message
        state.mypageErrorData.message = "오류가 발생하였습니다";
      }
    },
    // 유저 정보 초기화
    INIT_USER_INFO(state) {
      state.profile.social_type = "";
      state.profile.email_id = "";
      state.profile.country_number_id = "";
      state.profile.phone_id = "";
      state.profile.email = "";
      state.profile.country_number = "";
      state.profile.phone = "";
      state.profile.nickname = "";
      state.profile.name = "";
      state.profile.gender = "";
      state.profile.birth = "";
      state.profile.parent_phone = "";
      state.profile.parent_name = "";
      state.profile.change_pw_date = "";
      state.profile.regist_date = "";
      state.profile.agree_email_receive = "";
      state.profile.agree_phone_receive = "";
      state.profile.is_person = false;
      state.profile.is_legacy = false;
      state.profile.is_transfer = false;
      state.profile.is_id = false;
      state.profile.is_sns = false;
    },
    // 유저정보 입력
    SET_USER_INFO(state, response) {
      state.profile = response;
    },
    SET_USER_POSSESSION_INFO(state, response) {
      state.userPossessionInfo = response;
    },
    // Init Create Session Key
    INIT_SESSION_KEY(state) {
      state.common.sessionKey = "";
    },
    // Add Create Session Key
    CREATE_SESSION_KEY(state, response) {
      state.common.sessionKey = response.session_key;
    },
    // Update Integrated Info
    UPDATE_INTEGRATED_INFORMATION(state, response) {
      state.profile.name = response.name;
      state.profile.birth = response.birth;
    },
    // Init Connection Service List
    INIT_CONNECTION_SERVICE_LIST(state) {
      state.service.list = [];
    },
    // ADD Connection Service List
    ADD_CONNECTION_SERVICE_LIST(state, response) {
      response = response.terms.filter((item) => item.is_active);

      state.service.list = response;
    },
    // Init Send Result
    INIT_SEND_RESULT(state) {
      state.service.possession.sendResult = false;
      state.service.possession.certifycateResult = false;
      state.service.possession.changeResult = false;
    },
    // Init Send Result
    INIT_SEND_TYPE(state, reseponse) {
      state.service.possession.sendType = reseponse;
    },
    // Set Send Result
    SET_SEND_RESULT(state, response) {
      state.service.possession.sendResult = true;
      state.service.possession.sendCount = response.retry_count;
    },
    // Init Checked Certifycate
    INIT_CHECKED_CERTIFYCATE(state) {
      state.service.possession.certifycateResult = false;
      state.service.possession.changeResult = false;
    },
    // Set Checked Certifycate
    SET_CHECKED_CERTIFYCATE(state) {
      state.service.possession.certifycateResult = true;
    },
    // Updated Phone
    UPDATE_PHONE(state, response) {
      state.profile.country_number = response.country_number;
      state.profile.phone = response.phone;
      state.service.info.country_number = response.country_number;
      state.service.info.phone = response.phone;
      state.service.possession.changeResult = true;
    },
    // Updated Email
    UPDATE_EMAIL(state, response) {
      state.profile.email = response.email;
      state.service.email = response.email;
      state.service.possession.changeResult = true;
    },
    // Init Service Info
    INIT_SERVICE_INFO(state) {
      state.service.info = {};
      state.service.updateResult = false;
    },
    // ADD Service Info
    ADD_SERVICE_INFO(state, response) {
      state.service.info = response;
    },
    // Update Service Info
    Update_SERVICE_INFO(state) {
      state.service.updateResult = true;
    },
    // Init Margeting Send Agree
    INIT_MARKETING_SEND_AGREE(state) {
      state.setting.marketingAgree = "";
    },
    // Set Margeting Send Agree
    SET_MARKETING_SEND_AGREE(state, response) {
      state.setting.marketingAgree = response;
    },
    // Init Term Path
    INIT_TERM_PATH(state, response) {
      response.forEach((item) => (item.terms_popup_open = false));

      state.setting.terms = response;
    },
    UPDATE_TERM(state, termList) {
      state.setting.terms = termList;
    },
    // Init token
    INIT_MYPAGE_TOKEN(state) {
      state.mypageToken.access_token = "";
      state.mypageToken.refresh_token = "";
    },
    // Set token
    SET_MYPAGE_TOKEN(state, response) {
      state.mypageToken.access_token = response.access_token;
      state.mypageToken.refresh_token = response.refresh_token;
    },
    async SET_MYPAGE_CHANGE_PASSWORD_DATE(state, response) {
      state.profile.change_pw_date = response;
    }
  },
  actions: {
    // Select Integrated User Info
    async getIntegratedUserInfo({ commit, getters }, payload) {
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          Authorization: payload.accessToken,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init
      commit("INIT_USER_INFO");

      // Call Api
      const { data } = await Api.getUserInfo(headerOption);
      if (data.code === 21000) {
        const value = { ...data.value };

        if (CommonUtil.isNotEmpty(value.phone_id)) {
          value.phone_id = EncryptionUtil.aes256Decrypt(value.phone_id);
        }

        if (CommonUtil.isNotEmpty(value.name)) {
          value.name = EncryptionUtil.aes256Decrypt(value.name);
        }

        if (CommonUtil.isNotEmpty(value.phone)) {
          value.phone = EncryptionUtil.aes256Decrypt(value.phone);
        }

        if (CommonUtil.isNotEmpty(value.parent_phone)) {
          value.parent_phone = EncryptionUtil.aes256Decrypt(value.parent_phone);
        }

        if (CommonUtil.isNotEmpty(value.parent_name)) {
          value.parent_name = EncryptionUtil.aes256Decrypt(value.parent_name);
        }

        commit("SET_USER_INFO", value);
        window.dataLayer.push({ hashMemberNo: value.hash_member_no });
        window.dataLayer.push({ hashServiceMemberNo: value.hash_service_member_no });
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    async getUserPossessionInfo({ commit, getters }, payload) {
      const param = { session_key: payload.sessionKey };
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };
      const { data } = await Api.getUserPossessionInfo(param, headerOption);
      if (data.code === 21000) {
        commit("SET_USER_POSSESSION_INFO", data.value);
      }
    },
    // Create Session Key
    async createMypageSessionKey({ commit, getters }, payload) {
      const param = { use_type: payload.useType };
      const headerOption = { headers: { "X-Client-Id": getters.getXClientInfo.ID } };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      commit("INIT_SESSION_KEY");

      // Call Api Create Session Key
      const { data } = await Api.getSessionKey(param, headerOption);
      if (data.code === 21000) {
        commit("CREATE_SESSION_KEY", data.value);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Update Integrated User Info
    async updateIntegratedUserInfo({ commit, getters }, payload) {
      const param = { session_key: payload.sessionKey };
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Updated Integrated User information
      const { data } = await Api.updateIntegratedUserInfo(param, headerOption);
      if (data.code === 21000) {
        commit("UPDATE_INTEGRATED_INFORMATION", data.value);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Select Serviced List
    async getServiceList({ commit, getters }, payload) {
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Connection Service List
      commit("INIT_CONNECTION_SERVICE_LIST");

      // Call Api Selected User Information
      const { data } = await Api.getServiceList(headerOption);
      if (data.code === 21000) {
        commit("ADD_CONNECTION_SERVICE_LIST", data.value);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Select Serviced User Info (@deprecated)
    async getServicedUserInfo({ commit, getters }, payload) {
      const { access_token, service_id } = payload;
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: access_token }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Service Info
      commit("INIT_SERVICE_INFO");

      // Call Api Selected User Information
      const { data } = await Api.getServiceUserInfo(service_id, headerOption);
      if (data.code === 21000) {
        commit("ADD_SERVICE_INFO", data.value);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // 서비스 정보 조회 API
    selectServicedUserInformation({ getters }, payload) {
      const { access_token, service_id } = payload;
      const config = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          Authorization: access_token,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      return Api.getServiceUserInfo(service_id, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          const value = { ...data.value };

          // 이투스 이름
          if (CommonUtil.isNotEmpty(value.name)) {
            value.name = EncryptionUtil.aes256Decrypt(value.name);
          }

          // 워드마스터 이름
          if (CommonUtil.isNotEmpty(value.nickname)) {
            value.nickname = EncryptionUtil.aes256Decrypt(value.nickname);
          }

          // 디온 이름
          if (CommonUtil.isNotEmpty(value.nick_name)) {
            value.nick_name = EncryptionUtil.aes256Decrypt(value.nick_name);
          }

          if (CommonUtil.isNotEmpty(value.phone)) {
            value.phone = EncryptionUtil.aes256Decrypt(value.phone);
          }

          if (CommonUtil.isNotEmpty(value.parent_mobile)) {
            value.parent_mobile = EncryptionUtil.aes256Decrypt(value.parent_mobile);
          }

          return value;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 서비스 정보 변경 API
    updateServicedUserInformation({ getters }, payload) {
      const { access_token, service_id, ...param } = payload;

      const config = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          Authorization: access_token,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      return Api.updateServiceUserInfo(service_id, param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 서비스 회원 광고 수신 동의 변경
    updateServicedMarketingAgree({ getters }, payload) {
      const { access_token, ...param } = payload;
      const config = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: access_token }
      };

      return Api.updateServicedMarketingAgree(param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // Init Send
    async initSend({ commit }, payload) {
      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Send Result
      commit("INIT_SEND_RESULT");
      commit("INIT_SEND_TYPE", payload);
    },
    // Request Possession (SMS, EMAIL)
    async requestPossession({ commit, getters }, payload) {
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Send Result
      commit("INIT_SEND_RESULT");

      // Call Api Request Possession (SMS, EMAIL)
      const { data } = await Api.requestPossession(payload, headerOption);
      if (data.code === 21000) {
        commit("SET_SEND_RESULT", data.value);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Checked Possession (SMS, EMAIL)
    async checkPossession({ commit, getters }, payload) {
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Send Result
      commit("INIT_CHECKED_CERTIFYCATE");

      // Call Api Checked Possession (SMS, EMAIL)
      const { data } = await Api.checkPossession(payload, headerOption);
      if (data.code === 21000) {
        commit("SET_CHECKED_CERTIFYCATE");
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Update Phone
    async updatePhone({ commit, getters }, payload) {
      const param = {
        session_key: payload.sessionKey,
        country_number: payload.countryNumber,
        phone: payload.phone,
        client_id: payload.clientId
      };
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          Authorization: payload.accessToken,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Change Phone
      const { data } = await Api.changePhone(param, headerOption);
      if (data.code === 21000) {
        commit("UPDATE_PHONE", data.value);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Update Email
    async updateEmail({ commit, getters }, payload) {
      const param = {
        session_key: payload.sessionKey,
        email: payload.email,
        client_id: payload.clientId
      };
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Change Phone
      const { data } = await Api.changeEmail(param, headerOption);
      if (data.code === 21000) {
        commit("UPDATE_EMAIL", payload.email);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Update Serviced User Info
    async updateServicedUserInfo({ commit, getters }, payload) {
      const serviceId = getters.clientInfo.SERVICE_ID;
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };
      const param = {
        profiles: payload.profiles
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Update Service User Information
      const { data } = await Api.updateServiceUserInfo(serviceId, param, headerOption);
      if (data.code === 21000) {
        commit("Update_SERVICE_INFO");
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Init Marketing Send Agree
    async initMarketingSendAgree({ commit, getters }, payload) {
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Marketing Send Agree
      commit("INIT_MARKETING_SEND_AGREE");

      // Call Api Selected integreated Marketing Agree
      const { data } = await Api.getIntegreatedMarketingAgree(headerOption);
      if (data.code === 21000) {
        commit("SET_MARKETING_SEND_AGREE", data.value.email_send_agree && data.value.sms_send_agree);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Update Marketing Send Agree
    async updateMarketingSendAgree({ commit, getters }, payload) {
      const param = {
        email_send_agree: payload.marketingSendAgree,
        sms_send_agree: payload.marketingSendAgree
      };
      const headerOption = {
        headers: { "X-Client-Id": getters.clientInfo.ID, Authorization: payload.accessToken }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");
      // Init Marketing Send Agree
      commit("INIT_MARKETING_SEND_AGREE");

      // Call Api Update integreated Marketing Agree
      const { data } = await Api.updateIntegreatedMarketingAgree(param, headerOption);
      if (data.code === 21000) {
        commit("SET_MARKETING_SEND_AGREE", payload.marketingSendAgree);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    // Init Term List
    async initTermList({ commit, getters }, payload) {
      const headerOption = {
        headers: { "X-Client-Id": getters.getXClientInfo.ID }
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Terms List
      const { data } = await Api.getTermList(payload, headerOption);
      if (data.code === 21000) {
        commit("INIT_TERM_PATH", data.value.integration_terms);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    },
    async checkUsableEmail({ commit, getters }, payload) {
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID
        }
      };
      const param = {
        session_key: payload.sessionKey,
        email: payload.email
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Change Phone
      return await Api.checkUsableEmail(param, headerOption);
    },
    async checkDuplicatePhone({ commit, getters }, payload) {
      const headerOption = { headers: { "X-Client-Id": getters.getXClientInfo.ID } };
      const param = {
        session_key: payload.sessionKey,
        phone: payload.phone
      };
      commit("INIT_MYPAGE_ERROR_DATA");

      return await Api.checkDuplicatePhone(param, headerOption);
    },
    async checkUsableLinkerNickname({ commit, getters }, payload) {
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID
        }
      };
      const param = {
        session_key: payload.sessionKey,
        nickname: payload.nickname
      };

      // Error Handler Init
      commit("INIT_MYPAGE_ERROR_DATA");

      // Call Api Change Phone
      return await Api.checkUsableLinkerNickname(param, headerOption);
    },
    async getIntegratedUserChangePassWordDate({ commit, getters }, payload) {
      const headerOption = {
        headers: {
          "X-Client-Id": getters.clientInfo.ID,
          Authorization: payload.accessToken,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      // Call Api
      const { data } = await Api.getUserInfo(headerOption);

      if (data.code === 21000) {
        commit("SET_MYPAGE_CHANGE_PASSWORD_DATE", data.value.change_pw_date);
      } else {
        commit("SET_MYPAGE_ERROR_DATA", data);
      }
    }
  }
};
